import React from "react";
import styles from "./styles.module.scss";
import PagePanel from "app/components/PagePanel";
import DropdownButton from "app/components/DropdownButton";
import TabButton from "app/components/Button/TabButton";
import { cls } from "app/utils";
import SpaceSettings from "app/components/SpaceTabsContainer/SpaceSettings";
import { useTranslation } from "react-i18next";

interface SpaceHeaderProps {
  displaySettings?: boolean;
  title: string;
  avatar?: string;
  sport?: string;
  athleteId?: string;
  athleteExternalId?: string;
  email?: string;
  phone?: string;
  role?: string;
  onTimelineClick?: () => void;
  onScheduleClick?: () => void;
  onMembersClick?: () => void;
  hasScheduleAccess?: boolean;
}

const SpaceHeader = ({
  displaySettings = true,
  title,
  sport,
  avatar,
  athleteId,
  athleteExternalId,
  email,
  phone,
  role,
  onTimelineClick,
  onScheduleClick,
  onMembersClick,
  hasScheduleAccess,
}: SpaceHeaderProps) => {
  const { t } = useTranslation();

  const spaceSettingsBtn = (
    <DropdownButton
      btnClassName={styles.dropdown_btn_className}
      btnContent={<i className="ico ico-cog" />}
    >
      <SpaceSettings />
    </DropdownButton>
  );

  return (
    <PagePanel
      panelClassName={styles.page_panel}
      title={title || "Space"}
      subTitle={sport}
      avatar={avatar}
      athleteId={athleteId}
      athleteExternalId={athleteExternalId}
      email={email}
      phone={phone}
      role={role}
      headerChildren={displaySettings && spaceSettingsBtn}
    >
      <div className={styles.navbar_wrapper}>
        {onTimelineClick && (
          <TabButton
            label={t("Timeline")}
            icon={<i className={cls("tab-icon ico ico-feed-o")} />}
            isActive={
              !window.location.pathname.includes("members") &&
              !window.location.pathname.includes("schedule")
            }
            onClick={onTimelineClick}
            className={styles.mobile}
            labelClassName={styles.tab_label}
          />
        )}
        {hasScheduleAccess && onScheduleClick && (
          <TabButton
            label={t("Schedule")}
            icon={<i className={cls("tab-icon ico ico-time")} />}
            isActive={window.location.pathname.includes("schedule")}
            onClick={onScheduleClick}
            className={styles.mobile}
            labelClassName={styles.tab_label}
          />
        )}
        {onMembersClick && (
          <TabButton
            label={t("Members")}
            icon={<i className={cls("tab-icon ico ico-tspace-o")} />}
            isActive={window.location.pathname.includes("members")}
            onClick={onMembersClick}
            className={styles.mobile}
            labelClassName={styles.tab_label}
          />
        )}
      </div>
    </PagePanel>
  );
};

export default SpaceHeader;
